// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3R9Ms","title":"styles_title__3gFnH"};